import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { Components } from '../../components';
import { NavService } from '../../services/nav.service'
import { StoryblokService } from '../../services/storyblok.service'
import { NgAnimateScrollService } from 'ng-animate-scroll'
import { ActivatedRoute } from '@angular/router'


@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {
  public loaded = false
  public story: any
  components = Components;

  @Input() body: any[];
  @Input() _editable: any;

  constructor(
    private navService: NavService,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private storyBlokService: StoryblokService,
    private animateScrollService: NgAnimateScrollService,
  ) { }

  ngOnInit() {
    this.storyBlokService.getStory('home', {version: 'draft'}).then(data => {
      this.story = data.story
      this.loaded = true

      this.route.queryParams.subscribe(params => {
        if(params['p'] === 'projects') {
          console.log('Projects')
          
          setTimeout(() => {
            this.animateScrollService.scrollToElement('project-list-target', 500)
          }, 100)
        }
      })
    })
  }

  // changeActiveNav(id) {
  //   this.navService.changeActiveNavItem(id, 'page component')
  // } 

  // public onIntersection({ target, visible }, id): void {
  //   if(visible) {
  //     this.changeActiveNav(id)
  //   }
  // }
}